import React from 'react';
import './Styles/Section.scss';
const Section=(props)=>{
    return(
        <div className="details-section">
            {props.title ? <h2  data-aos="fade-up"
        data-aos-delay={100}>{props.title}</h2> : null}
            {props.desc ? <p>{props.desc}</p> : null}
            {props.desc2 ? <p>{props.desc}</p> : null}
        </div>
    )
};
export default Section ;